<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <Navigation active="harvests"></Navigation>
    <div class="row">
      <div class="col-12 table-overlay">
        <div class="block">
        <div v-if="showLoader" class="overlay"></div>
        <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#5C7FD1" loading="loading" size="40" sizeUnit="px"></hash-loader>
          <div class="block-header bg-primary">
            <h3 class="block-title text-white"><i class="fa fa-cut"></i> Complete List of Harvests</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option text-white" @click.prevent="showPackagesCreationModal(0)">
                <i v-bind:disabled="showLoader" class="si si-plus"></i> Create package
              </button>
            </div>
          </div>
          <div class="block-content block-content-full table-overview">
            <table id="harvest-overview" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
              <thead>
                <tr>
                  <th class="text-center">Id</th>
                  <th class="text-center">Name</th>
                  <th class="text-center">Harvest type</th>
                  <th class="text-center">current weight</th>
                  <th class="text-center">start Date</th>
                  <th class="text-center no-sorting">Advance</th>
                </tr>
              </thead>
              <tbody>{{ getHarvestEntries }}
                <tr v-for="(harvest, index) in harvests" :key="index">
                  <td class="text-center font-size-sm">{{ harvest.Id }}</td>
                  <td class="text-center font-size-sm text-break">
                    <router-link :to="`/harvests/details/${harvest.Id}`">{{ harvest.Name }}</router-link>
                  </td>
                  <td class="text-center font-size-sm">{{ harvest.HarvestType }}</td>
                  <td class="text-center font-size-sm">{{ harvest.CurrentWeight }} {{ harvest.UnitOfWeightName }}</td>
                  <td class="text-center font-size-sm">
                    <em class="text-muted"> {{ harvest.HarvestStartDate }}</em>
                  </td>
                  <td class="text-center button-loader">
                    <button class="btn btn-primary" title="Remove Waste" @click.prevent="showRemoveWasteModal(harvest.Id)">
                      <i class="fa fa-trash-alt text-white"></i>
                    </button>
                    <button class="btn btn-primary" title="Create Package" @click.prevent="showPackagesCreationModal(harvest.Id)">
                      <i class="fa fa-box-open text-white"></i>
                    </button>
                    <button type="button" @click.prevent="finish(harvest.Id)" class="btn btn-sm btn-primary" title="Click to finish.">
                      <div><span>Finish</span></div>
                      <span class="modal-loader d-none" :id="`finish-button-${harvest.Id}`">
                        <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                      </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    
    <!--Begin remove-waste modal-window-->
    <RemoveWaste
      ref="removeWaste"
      @loadHarvest="fetch"
    ></RemoveWaste>
    <!--End remove-waste modal-window-->

    <!--Begin create-package-from-harvest modal-window-->
    <CreatePackage
      ref="createPackage"
    ></CreatePackage>
    <!--End create-package-from-harvest modal-window-->
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import Navigation from '@/components/Navigation';
import RemoveWaste from '@/components/modals/RemoveWaste';
import CreatePackage from '@/components/modals/CreatePackage';
import AlertMessageModal from '@/components/AlertMessageModal';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';

Vue.use(VueSpinners);
export default {
  name: 'HarvestOverview',
  data() {
    return {
      harvests: [],
      isTableEnabled: false,
      showLoader: false,
      showButtonLoader: false
    };
  },
  components: {
    Navigation,
    AlertMessageModal,
    HashLoader,
    RemoveWaste,
    CreatePackage
  },
  created() {
    this.fetch(false);
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
    this.loadFile('/static/js/oneui.app.min.js', 'js');  
    this.loadFile('/static/js/be_tables_datatables.min.js', 'js');    
  },
  mounted() {
    $('.select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: $(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });
    $('.package-select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: $(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    getHarvestEntries() {
      if (this.$store.state.library.harvests.length) {
        return this.enableDataTable(this.$store.state.library.harvests);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllHarvests']),
    ...mapGetters('library', ['getHarvests']),
    async fetch(force) {
      if (force || this.getHarvests().length === 0) {
        this.showLoader = true;
        await this.getAllHarvests();
      }
      if (this.getHarvests().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#harvest-overview').DataTable();
        table.destroy();
      }
      vm.harvests    = data;
      helper.prepareDataTable('#harvest-overview');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showRemoveWasteModal(harvestId) {
      this.$refs.removeWaste.$data.id = harvestId;
      jQuery('#remove-waste').modal('show');
    },
    showPackagesCreationModal(harvestId) {
      this.$refs.createPackage.setData(harvestId, 'primary');
      jQuery('#harvest-create-package').modal('show');
    },
    finish(id) {
      let vm = this;
      jQuery('#finish-button-' + id).removeClass('d-none');
      helper.sendPostRequest('/harvests/finish', {
        'Id': id,
        'ActualDate': new Date().toJSON().slice(0,10)
      }).then((data) => {
        if (data.status === 'success') {
          helper.showSuccessModal(data.message);
          vm.fetch(true);
        } else {
          jQuery('#finish-button-' + id).addClass('d-none');
          helper.showErrorModal(data.message);
        }
      });
    }
  },
  beforeDestory() {
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
  }
};
</script>
<style>
.select2-selection__arrow {
  top: 6px !important;
}
</style>



// WEBPACK FOOTER //
// source/components/HarvestOverview.vue